module.exports = __webpack_public_path__ + "img/oncoming_fist.75aed2e7.gif";